/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

export function AdminCategories() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [categories, setCategories] = useState<any[]>([]);

  const [selectedMainCateId, setSelectedMainCateId] = useState<number>();

  const [mainCateAdd, setMainCateAdd] = useState<string>('');
  const [mainCateMod, setMainCateMod] = useState<string>('');

  const [subCateAdd, setSubCateAdd] = useState<string>('');
  const [subCateMod, setSubCateMod] = useState<string>('');

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = async () => {
    await server
      .getCategories()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setCategories(payload);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  return (
    <main className="categories wrapper">
      <div className="title">
        <h1>카테고리 설정</h1>
      </div>
      <div className="content">
        <section>
          <div className="title">
            <label htmlFor="category-01">대분류</label>
            <input
              type="text"
              id="category-01"
              onChange={(e) => {
                setMainCateAdd(e.target.value);
              }}
            />
            <button
              type="button"
              onClick={async () => {
                if (window.confirm('추가 하시겠습니까?')) {
                  await server
                    .addBookCategory({ name: mainCateAdd, displayOrder: 5 })
                    .then((payload) => {
                      if (!payload) {
                        dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
                      } else if (payload.code === 400 || payload.code === 500) {
                        dispatch(toast.error({ message: '파라미터 오류' }));
                      }
                      getCategories();
                    })
                    .catch((error) => {
                      dispatch(
                        toast.error({
                          message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.',
                        })
                      );
                      console.log(error);
                    });
                }
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
              </svg>
            </button>
          </div>
          <ul>
            {categories.map((main) => {
              return (
                <li key={main.id}>
                  <input
                    type="text"
                    defaultValue={main.name || ''}
                    onClick={() => {
                      setSelectedMainCateId(main.id);
                    }}
                    onChange={(e) => {
                      setMainCateMod(e.target.value);
                    }}
                  />
                  <button
                    type="button"
                    onClick={async () => {
                      if (window.confirm('수정 하시겠습니까?')) {
                        await server
                          .modBookCategory(main.id, { name: mainCateMod })
                          .then((payload) => {
                            if (!payload) {
                              dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
                            } else if (payload.code === 400 || payload.code === 500) {
                              dispatch(toast.error({ message: '파라미터 오류' }));
                            }
                            getCategories();
                          })
                          .catch((error) => {
                            dispatch(
                              toast.error({
                                message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.',
                              })
                            );
                            console.log(error);
                          });
                      }
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    onClick={async () => {
                      if (window.confirm('삭제 하시겠습니까?')) {
                        await server
                          .getBookCategory(main.id)
                          .then(async (payload) => {
                            if (!payload) {
                              dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
                            } else if (payload.code === 400 || payload.code === 500) {
                              dispatch(toast.error({ message: '파라미터 오류' }));
                            } else if (
                              payload.children.length === 0 ||
                              payload.children.length === undefined
                            ) {
                              setSelectedMainCateId(undefined);
                              await server
                                .deleteBookCategory(main.id)
                                .then(() => {
                                  getCategories();
                                })
                                .catch((error) => {
                                  dispatch(
                                    toast.error({
                                      message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.',
                                    })
                                  );
                                  console.log(error);
                                });
                            } else {
                              dispatch(
                                toast.error({ message: '먼저 소분류 카테고리를 삭제해주세요.' })
                              );
                            }
                          })
                          .catch((error) => {
                            dispatch(
                              toast.error({
                                message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.',
                              })
                            );
                            console.log(error);
                          });
                      }
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z" />
                    </svg>
                  </button>
                </li>
              );
            })}
          </ul>
        </section>
        <section>
          <div className="title">
            <label htmlFor="category-02">소분류</label>
            <input
              type="text"
              id="category-02"
              onChange={(e) => {
                setSubCateAdd(e.target.value);
              }}
            />
            <button
              type="button"
              onClick={async () => {
                if (selectedMainCateId !== undefined) {
                  if (window.confirm('추가 하시겠습니까?')) {
                    await server
                      .addBookCategory({
                        name: subCateAdd,
                        displayOrder: 5,
                        parentId: +selectedMainCateId,
                      })
                      .then((payload) => {
                        if (!payload) {
                          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
                        } else if (payload.code === 400 || payload.code === 500) {
                          dispatch(toast.error({ message: '파라미터 오류' }));
                        }
                        getCategories();
                      })
                      .catch((error) => {
                        dispatch(
                          toast.error({
                            message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.',
                          })
                        );
                        console.log(error);
                      });
                  }
                }
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
              </svg>
            </button>
          </div>
          {selectedMainCateId !== undefined &&
            categories
              .find((subCate) => subCate.id === selectedMainCateId)
              .children?.map((subCategory: any) => (
                <li key={subCategory.id}>
                  <input
                    type="text"
                    defaultValue={subCategory.name || ''}
                    onChange={(e) => {
                      setSubCateMod(e.target.value);
                    }}
                  />
                  <button
                    type="button"
                    onClick={async () => {
                      if (window.confirm('수정 하시겠습니까?')) {
                        await server
                          .modBookCategory(subCategory.id, {
                            name: subCateMod,
                            displayOrder: 2,
                            parentId: +selectedMainCateId,
                          })
                          .then((payload) => {
                            if (!payload) {
                              dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
                            } else if (payload.code === 400 || payload.code === 500) {
                              dispatch(toast.error({ message: '파라미터 오류' }));
                            }
                            getCategories();
                          })
                          .catch((error) => {
                            dispatch(
                              toast.error({
                                message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.',
                              })
                            );
                            console.log(error);
                          });
                      }
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    onClick={async () => {
                      if (window.confirm('삭제 하시겠습니까?')) {
                        await server
                          .deleteBookCategory(subCategory.id)
                          .then((payload) => {
                            if (!payload) {
                              dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
                            } else if (payload.code === 400 || payload.code === 500) {
                              dispatch(toast.error({ message: '파라미터 오류' }));
                            }
                            getCategories();
                          })
                          .catch((error) => {
                            dispatch(
                              toast.error({
                                message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.',
                              })
                            );
                            console.log(error);
                          });
                      }
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z" />
                    </svg>
                  </button>
                </li>
              ))}
        </section>
      </div>
    </main>
  );
}
